import { render } from "./CorpusSelection.vue?vue&type=template&id=50eb6620&scoped=true"
import script from "./CorpusSelection.vue?vue&type=script&lang=js"
export * from "./CorpusSelection.vue?vue&type=script&lang=js"

import "./CorpusSelection.vue?vue&type=style&index=0&id=50eb6620&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eb6620"]])

export default __exports__